import '../../assets/fonts'
import '../../../global.d'
import React from 'react'
import { Provider } from 'react-redux'
import { MsalProvider } from '@azure/msal-react'
import { GlobalStyle } from '../../styles/global'
import Routes from '../routes'
import { store } from '../../../main/store/store'
import Modal from '../ui/components/pop_up/pop_up'

function App({ instance }: any): JSX.Element {
  return (
    <MsalProvider instance={instance}>
      <Provider store={store}>
        <GlobalStyle />
        <Routes />
        <Modal />
      </Provider>
    </MsalProvider>
  )
}

export default App
